import Siat from "../";

const routes = [
	{ name: "Scelta Pratiche", path: "/siatpratichescelta", component: Siat.SiatPraticheSceltaListPage, meta: { title: "Scelta Pratiche" } },
	{ name: "Pratiche Assegnate", path: "/siatpraticheassegnate", component: Siat.SiatPraticheAssegnateListPage, meta: { title: "Pratiche Assegnate" } },
	{ name: "Pratiche", path: "/pratichesiat", component: Siat.SiatPraticheListPage, meta: { title: "Pratiche Siat" } },
	{ name: "Pratiche Siat Notifiche", path: "/notifichesiat", component: Siat.SiatNotificheListaPage, meta: { title: "Lista Notifiche" } },
	{ name: "Pratiche", path: "/pratichesiat/:id", component: Siat.SiatPraticheEditPage, meta: { title: "Pratiche Siat" } },
	{ name: "Riepilogo Pratiche", path: "/riepilogopratiche", component: Siat.SiatRiepilogoPraticheListPage, meta: { title: "Riepilogo Siat" } }
];
export default routes;
